import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { auth, db } from "./firebase";
import { doc, getDoc, onSnapshot } from "firebase/firestore";

// Pages
import ProfessionalNDT from "./pages/uploadForm";
import LoginPage from "./pages/LoginPage";
import SignupPage from "./pages/SignupPage";
import DashboardLayout from "./pages/DashboardLayout"; // The new layout
import NDTEngine from "./pages/Engine";
import HomePage from "./pages/HomePage";
import About from "./pages/About";
import FooterPage from "./pages/FooterPage";
import LiveReportPreview from "./pages/LiveReportPreview";
import { onAuthStateChanged } from "firebase/auth";
import CompleteProfile from "./pages/CompleteProfile";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);
  return null;
}

function App() {
  const [profile, setProfile] = useState(null);

  // Global Profile Fetching Logic
// In App.js
useEffect(() => {
  let unsubscribeProfile = null; // 1. Define a variable to hold the profile listener

  const unsubscribeAuth = onAuthStateChanged(auth, (user) => {
    if (user) {
      console.log("🔐 Auth State: User Logged In", user.uid);
      
      // 2. Start the Real-Time Profile Listener
      const userDocRef = doc(db, "users", user.uid);
      unsubscribeProfile = onSnapshot(userDocRef, (docSnap) => {
        if (docSnap.exists()) {
          console.log("⛽ Live Fuel Sync:", docSnap.data().credits_remaining);
          setProfile({ uid: user.uid, ...docSnap.data() });
        }
      }, (error) => {
        console.error("❌ Profile Sync Error:", error);
      });

    } else {
      console.log("🔓 Auth State: Logged Out");
      // 3. Clean up the profile listener if the user logs out
      if (unsubscribeProfile) unsubscribeProfile();
      setProfile(null);
    }
  });

  // 4. Final Cleanup: Stop both listeners when the app closes/unmounts
  return () => {
    unsubscribeAuth();
    if (unsubscribeProfile) unsubscribeProfile();
  };
}, []);

  return (
    <Router>
      <ScrollToTop />
      <Routes>
        {/* PUBLIC ROUTES */}
        <Route path="/" element={<ProfessionalNDT />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/completeprofile" element={<CompleteProfile />} />

        
        <Route path="/home" element={<HomePage />} />
        <Route path="/about" element={<About />} />
        <Route path="/engine" element={<NDTEngine />} />
        <Route path="/reporteditor" element={<LiveReportPreview />} />
        
        {/* DYNAMIC FOOTER PAGES */}
        <Route path="/:pageId" element={<FooterPage />} />

        {/* DASHBOARD NESTED ROUTES */}
        {/* The /* tells React Router there are sub-routes inside DashboardLayout */}
        <Route path="/dashboard/*" element={<DashboardLayout profile={profile} />} />
        
      </Routes>
    </Router>
  );
}

export default App;